import { useNavigate } from "react-router-dom";
import { ProductGrid } from "../product";
import { SEO } from "../SEO";

export function StreetwearSection({ products, isPage }) {
  const navigate = useNavigate();
  const streetwearProducts = products.filter(p => p.collection === "Streetwear");
  
  const taglines = [
    "Different by Design.",
    "Stand Out. Stay Real.",
    "Unapologetically Me.",
    "Born to Lead, Not Follow."
  ];
  
  return (
    <section className={`py-20 px-4 ${isPage ? 'pt-32' : ''} bg-gradient-to-b from-black to-zinc-900`} data-testid="streetwear-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {isPage && <SEO title="Streetwear Collection" description="Shop Fresh Po'Boy Streetwear Collection. Bold designs, premium quality. T-Shirts, Hoodies & more. 10% OFF everything." path="/streetwear" />}          <span className="text-red-500 text-sm tracking-widest uppercase">Exclusive</span>
          <h2 className="text-white text-5xl sm:text-6xl font-bebas mt-2">Streetwear <span className="text-red-500">Collection</span></h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">Bold designs for those who refuse to blend in.</p>
          {isPage && (
            <button onClick={() => navigate("/streetwear/ladies")}
              className="mt-4 inline-flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-pink-600 to-rose-500 text-white font-semibold rounded-lg hover:from-pink-500 hover:to-rose-400 transition-all text-sm"
              data-testid="ladies-sub-link">
              Shop Ladies
            </button>
          )}
        </div>
        
        {isPage && (
          <div className="mb-16">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {taglines.map((tagline, index) => (
                <div 
                  key={tagline} 
                  className={`p-4 rounded-xl ${index % 2 === 0 ? 'bg-red-600/10 border border-red-600/30' : 'bg-cyan-400/10 border border-cyan-400/30'} text-center`}
                >
                  <p className={`text-sm sm:text-base font-bold ${index % 2 === 0 ? 'text-red-500' : 'text-cyan-400'}`}>
                    "{tagline}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <ProductGrid products={streetwearProducts} />
        {!isPage && streetwearProducts.length > 0 && (
          <div className="text-center mt-12">
            <button onClick={() => navigate('/streetwear')} className="px-8 py-4 bg-red-600 text-white font-semibold hover:bg-red-500 transition-colors" data-testid="view-streetwear-collection-btn">View Full Collection</button>
          </div>
        )}
      </div>
    </section>
  );
}
